import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  assignDescriptions: {
    marginBottom: 20,
  },
  assignDescription: {
    display: 'block',
    fontSize: 10,
    fontWeight: 700,
    lineHeight: 2,
    color: theme.palette.text.secondary,
  },
  assignNotes: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    fontStyle: 'italic',
    color: theme.palette.text.primary,
    marginBottom: 10,
  },
  serialInput: {
    textTransform: 'uppercase',
    fontWeight: 500,
    letterSpacing: '1rem',
  },
  statusLabelTitle: {
    fontSize: 12,
  },
}));
